<template>
    <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text><div v-html='message'></div></v-card-text>
    </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'MessageModal',
    data() {
      return {
        title: null,
        message: null,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      if (this.data.stored) {
        this.title = this.data.stored.title;
        this.message = this.data.stored.message;
      }
    },
  };
</script>
